(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jsid-cart-main"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('click', function(event) {

  var plus = event.target.closest('[data-jsid-qty-plus]');
  var minus = event.target.closest('[data-jsid-qty-minus]');

  if (!plus && !minus) return;

  var controls = event.target.closest('.jsid-qty-controls');

  if (!controls) return;

  var input = controls.querySelector('[data-jsid-qty-input]');

  if (!input) return;

  var currentValue = parseInt(input.value || '0', 10);

  if (plus) {
    input.value = currentValue + 1;
  }

  if (minus) {
    input.value = Math.max(0, currentValue - 1);
  }

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jsid-gift-card"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('click',function(e){

  var thumb=e.target.closest('.jsid-thumb');

  if(!thumb)return;

  var section=thumb.closest('.jsid-giftcard');

  if(!section)return;

  var id=thumb.getAttribute('data-target-media');


  section
    .querySelectorAll('.jsid-thumb')
    .forEach(function(item){

      item.classList.toggle(
        'is-active',
        item===thumb
      );

    });


  section
    .querySelectorAll('.jsid-media-slide')
    .forEach(function(slide){

      slide.classList.toggle(
        'is-active',
        slide.getAttribute('data-media-id')===id
      );

    });

});


document.addEventListener('click',function(e){

  var button=e.target.closest(
    '[data-jsid-gift-variant]'
  );

  if(!button)return;

  var section=button.closest(
    '.jsid-giftcard'
  );

  if(!section)return;


  var variantId=
    button.getAttribute(
      'data-jsid-gift-variant'
    );

  var price=
    button.getAttribute(
      'data-price'
    );

  var shortPrice=
    button.getAttribute(
      'data-price-short'
    );

  var available=
    button.getAttribute(
      'data-available'
    )==='true';

  var mediaId=
    button.getAttribute(
      'data-media-id'
    );


  section
    .querySelectorAll(
      '[data-jsid-gift-variant]'
    )
    .forEach(function(item){

      item.classList.toggle(
        'is-active',
        item===button
      );

    });


  var idInput=section.querySelector(
    '[data-jsid-variant-id]'
  );

  if(idInput){

    idInput.value=variantId;

    idInput.dispatchEvent(
      new Event(
        'change',
        {
          bubbles:true
        }
      )
    );

  }


  var priceNode=section.querySelector(
    '[data-product-price]'
  );

  if(priceNode){
    priceNode.textContent=price;
  }


  var addButton=section.querySelector(
    '[data-jsid-add-button]'
  );

  if(addButton){

    addButton.disabled=!available;

    if(available){

      addButton.textContent=
        'ADD GIFT CARD — ' +
        shortPrice;

    }else{

      addButton.textContent=
        'UNAVAILABLE';

    }

  }


  if(mediaId){

    var mediaThumb=
      section.querySelector(
        '.jsid-thumb[data-target-media="' +
        mediaId +
        '"]'
      );

    if(mediaThumb){
      mediaThumb.click();
    }

  }


  if(history.replaceState){

    var url=new URL(
      window.location.href
    );

    url.searchParams.set(
      'variant',
      variantId
    );

    history.replaceState(
      {},
      '',
      url.toString()
    );

  }

});


document.addEventListener('change',function(e){

  var choice=e.target.closest(
    '[data-jsid-recipient-choice]'
  );

  if(!choice)return;

  var section=choice.closest(
    '.jsid-giftcard'
  );

  if(!section)return;


  var recipientMode=
    choice.value==='recipient';


  var fields=section.querySelector(
    '[data-jsid-recipient-fields]'
  );


  section
    .querySelectorAll(
      '.jsid-choice-card'
    )
    .forEach(function(card){

      var radio=card.querySelector(
        '[data-jsid-recipient-choice]'
      );

      card.classList.toggle(
        'is-active',
        radio && radio.checked
      );

    });


  if(fields){

    fields.classList.toggle(
      'is-open',
      recipientMode
    );

    fields.setAttribute(
      'aria-hidden',
      recipientMode
        ? 'false'
        : 'true'
    );

  }


  section
    .querySelectorAll(
      '[data-jsid-recipient-input],' +
      '[data-jsid-recipient-email],' +
      '[data-jsid-send-date],' +
      '[data-jsid-recipient-flag],' +
      '[data-jsid-timezone-offset]'
    )
    .forEach(function(field){

      field.disabled=
        !recipientMode;

    });


  var email=section.querySelector(
    '[data-jsid-recipient-email]'
  );

  if(email){

    email.required=
      recipientMode;

  }


  var timezone=section.querySelector(
    '[data-jsid-timezone-offset]'
  );

  if(
    timezone &&
    recipientMode
  ){

    timezone.value=
      new Date()
        .getTimezoneOffset();

  }


  var dynamicCheckout=
    section.querySelector(
      '[data-jsid-dynamic-checkout]'
    );

  if(dynamicCheckout){

    dynamicCheckout.classList.toggle(
      'is-hidden',
      recipientMode
    );

  }

});


function jsidSetupGiftDate(section){

  var input=section.querySelector(
    '[data-jsid-send-date]'
  );

  if(!input)return;


  var today=new Date();

  var maximum=new Date();

  maximum.setDate(
    maximum.getDate()+90
  );


  function formatDate(date){

    var year=
      date.getFullYear();

    var month=
      String(
        date.getMonth()+1
      ).padStart(2,'0');

    var day=
      String(
        date.getDate()
      ).padStart(2,'0');


    return (
      year +
      '-' +
      month +
      '-' +
      day
    );

  }


  input.min=
    formatDate(today);

  input.max=
    formatDate(maximum);

}


function jsidInitGiftCards(){

  document
    .querySelectorAll(
      '.jsid-giftcard'
    )
    .forEach(function(section){

      jsidSetupGiftDate(section);


      var timezone=
        section.querySelector(
          '[data-jsid-timezone-offset]'
        );

      if(timezone){

        timezone.value=
          new Date()
            .getTimezoneOffset();

      }

    });

}


if(
  document.readyState==='loading'
){

  document.addEventListener(
    'DOMContentLoaded',
    jsidInitGiftCards
  );

}else{

  jsidInitGiftCards();

}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jsid-header"] && !Shopify.designMode) return;
  try {
    

/* ========================================
   JS-ID MOBILE MENU
======================================== */

document.addEventListener('click', function(event) {

  var toggle = event.target.closest('.jsid-menu-toggle');

  if (!toggle) return;


  var wrap = toggle.closest('.jsid-header-wrap');

  if (!wrap) return;


  var open = wrap.classList.toggle('is-menu-open');


  toggle.setAttribute(
    'aria-expanded',
    open ? 'true' : 'false'
  );

});


/* ========================================
   JS-ID NIGHT DRIVE FM
======================================== */

(function(){

  function initNightDriveFM(){

    var radios = document.querySelectorAll('[data-jsid-radio]');


    radios.forEach(function(radio){

      if (radio.dataset.radioReady === 'true') return;


      radio.dataset.radioReady = 'true';


      var audio = radio.querySelector('.jsid-radio-audio');
      var button = radio.querySelector('.jsid-radio-button');
      var icon = radio.querySelector('.jsid-radio-play');
      var text = radio.querySelector('.jsid-radio-buttontext');


      if (!audio || !button) return;



      function showPlaying(){

        radio.classList.add('is-playing');

        button.setAttribute(
          'aria-pressed',
          'true'
        );

        button.setAttribute(
          'aria-label',
          'Pause Night Drive FM'
        );


        if (icon){
          icon.textContent = '❚❚';
        }


        if (text){
          text.textContent = 'PAUSE';
        }

      }



      function showPaused(){

        radio.classList.remove('is-playing');

        button.setAttribute(
          'aria-pressed',
          'false'
        );

        button.setAttribute(
          'aria-label',
          'Play Night Drive FM'
        );


        if (icon){
          icon.textContent = '▶';
        }


        if (text){
          text.textContent = 'PLAY';
        }

      }



      button.addEventListener(
        'click',
        function(){

          if (audio.paused){

            audio.play()
              .then(function(){

                showPlaying();


                try{

                  sessionStorage.setItem(
                    'jsidNightDrivePlaying',
                    'true'
                  );

                }catch(error){}

              })
              .catch(function(error){

                console.log(
                  'Night Drive FM playback blocked:',
                  error
                );

                showPaused();

              });

          } else {

            audio.pause();

            showPaused();


            try{

              sessionStorage.setItem(
                'jsidNightDrivePlaying',
                'false'
              );

            }catch(error){}

          }

        }
      );



      audio.addEventListener(
        'play',
        showPlaying
      );


      audio.addEventListener(
        'pause',
        showPaused
      );



      /*
       * Remember track position while browsing.
       */

      audio.addEventListener(
        'timeupdate',
        function(){

          try{

            sessionStorage.setItem(
              'jsidNightDriveTime',
              String(audio.currentTime)
            );

          }catch(error){}

        }
      );



      try{

        var savedTime = parseFloat(
          sessionStorage.getItem(
            'jsidNightDriveTime'
          )
        );


        if (
          !isNaN(savedTime) &&
          savedTime > 0
        ){

          audio.addEventListener(
            'loadedmetadata',
            function(){

              if (
                savedTime <
                audio.duration
              ){

                audio.currentTime =
                  savedTime;

              }

            },
            {
              once:true
            }
          );

        }

      }catch(error){}



      showPaused();

    });

  }



  if (
    document.readyState ===
    'loading'
  ){

    document.addEventListener(
      'DOMContentLoaded',
      initNightDriveFM
    );

  } else {

    initNightDriveFM();

  }



  document.addEventListener(
    'shopify:section:load',
    initNightDriveFM
  );

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jsid-installation-guides"] && !Shopify.designMode) return;
  try {
    
(function(){
  var roots=document.querySelectorAll('.jsid-guides');
  roots.forEach(function(root){
    var search=root.querySelector('[data-jsid-guide-search]');
    var filters=root.querySelectorAll('[data-jsid-guide-filter]');
    var cards=root.querySelectorAll('[data-jsid-guide]');
    var empty=root.querySelector('[data-jsid-guide-empty]');
    var activeFilter='all';

    function applyFilters(){
      var query=(search&&search.value||'').trim().toLowerCase();
      var visible=0;
      cards.forEach(function(card){
        var title=card.getAttribute('data-title')||'';
        var vehicle=card.getAttribute('data-vehicle')||'';
        var matchesSearch=!query || title.indexOf(query)!==-1;
        var matchesVehicle=activeFilter==='all' || vehicle===activeFilter;
        var show=matchesSearch && matchesVehicle;
        card.hidden=!show;
        if(show)visible++;
      });
      if(empty)empty.hidden=visible!==0;
    }

    if(search)search.addEventListener('input',applyFilters);
    filters.forEach(function(button){
      button.addEventListener('click',function(){
        activeFilter=button.getAttribute('data-jsid-guide-filter')||'all';
        filters.forEach(function(x){x.classList.toggle('is-active',x===button)});
        applyFilters();
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jsid-miata-hero"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){
  var stage=event.target.closest('[data-jsid-night-car]');
  if(!stage)return;

  var image=stage.querySelector('.jsid-night-car');
  if(!image||!image.animate)return;

  image.animate(
    [
      {transform:'translateY(0) scale(1)'},
      {transform:'translateY(-8px) scale(1.02)'},
      {transform:'translateY(0) scale(1)'}
    ],
    {duration:420,easing:'ease-out'}
  );
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jsid-product-download"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(e){
  var thumb=e.target.closest('.jsid-download-thumb');
  if(!thumb)return;

  var section=thumb.closest('.jsid-download');
  if(!section)return;

  var id=thumb.getAttribute('data-download-target-media');

  section.querySelectorAll('.jsid-download-thumb').forEach(function(item){
    item.classList.toggle('is-active',item===thumb);
  });

  section.querySelectorAll('.jsid-download-media-slide').forEach(function(slide){
    slide.classList.toggle(
      'is-active',
      slide.getAttribute('data-download-media-id')===id
    );
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jsid-product-main"] && !Shopify.designMode) return;
  try {
    

/* ================================
   PRODUCT GALLERY
================================ */

document.addEventListener('click',function(e){

  var t=e.target.closest('.jsid-thumb');

  if(!t)return;

  var s=t.closest('.jsid-product');

  var id=t.getAttribute('data-target-media');


  s.querySelectorAll('.jsid-thumb').forEach(function(x){

    x.classList.toggle(
      'is-active',
      x===t
    );

  });


  s.querySelectorAll('.jsid-media-slide').forEach(function(x){

    x.classList.toggle(
      'is-active',
      x.getAttribute('data-media-id')===id
    );

  });

});


/* ================================
   JS-ID VARIANT PRICING — FAIL CLOSED
   Actual Shopify variant ID is the source of truth.
================================ */
function jsidVariantButton(section){
  var button=section.querySelector('[data-jsid-add-button]');
  if(!button)return;
  var v=section._jsidCurrentVariant;
  button.disabled=!!section._jsidCartBusy || !!section._jsidVariantLoading || !v || !v.available;
  button.textContent=section._jsidCartBusy?'ADDING…':section._jsidVariantLoading?'CHECKING…':!v?'UNAVAILABLE':v.available?'ADD TO CART':'SOLD OUT';
}
function jsidGetVariants(section){
  if(section._jsidVariantData)return section._jsidVariantData;
  var el=section.querySelector('[data-jsid-variants]');
  if(!el)throw new Error('Variant JSON missing');
  var data=JSON.parse(el.textContent);
  var seed=section.querySelector('[data-jsid-selected-variant]');
  if(seed){var selected=JSON.parse(seed.textContent);if(selected && !data.variants.some(function(v){return String(v.id)===String(selected.id);}))data.variants.push(selected);}
  section._jsidVariantData=data;
  return data;
}
function jsidSetVariant(section,v){
  section._jsidCurrentVariant=v;
  var id=section.querySelector('[data-jsid-variant-id]');
  if(id){id.value=v?String(v.id):'';id.disabled=!v;}
  var price=section.querySelector('[data-product-price]');
  if(price){price.innerHTML=!v?'<span>UNAVAILABLE</span>':v.hasCompare?'<span class="jsid-sale-price">'+v.price+'</span> <s>'+v.compare+'</s>':'<span>'+v.price+'</span>';}
  var availability=section.querySelector('[data-product-availability]');
  if(availability){availability.textContent=!v?'UNAVAILABLE':v.available?'IN STOCK':'SOLD OUT';availability.classList.toggle('is-sold-out',!v||!v.available);}
  var card=section.querySelector('[data-jsid-soldout-card]');
  if(card)card.classList.toggle('is-hidden',!v||v.available);
  var checkout=section.querySelector('.jsid-dynamic-checkout');
  if(checkout)checkout.hidden=!v||!v.available||!!section._jsidVariantLoading;
  jsidVariantButton(section);
  if(v && v.mediaId){
    var media=String(v.mediaId);
    if(section.querySelector('.jsid-media-slide[data-media-id="'+media+'"]')){
      section.querySelectorAll('.jsid-media-slide').forEach(function(slide){slide.classList.toggle('is-active',slide.dataset.mediaId===media);});
      section.querySelectorAll('.jsid-thumb').forEach(function(thumb){thumb.classList.toggle('is-active',thumb.dataset.targetMedia===media);});
    }
  }
}
function jsidResolveVariant(section,updateUrl){
  var selects=Array.from(section.querySelectorAll('[data-jsid-variant-select]')).sort(function(a,b){return Number(a.dataset.optionPosition)-Number(b.dataset.optionPosition);});
  var values=selects.map(function(s){return s.value;});
  var data;
  try{data=jsidGetVariants(section);}catch(error){console.error('JS-ID pricing error',error);jsidSetVariant(section,null);return;}
  var match=data.variants.find(function(v){return v.options&&v.options.length===values.length&&v.options.every(function(x,i){return String(x)===values[i];});});
  if(!selects.length){var initial=section.querySelector('[data-jsid-selected-variant]');match=initial?JSON.parse(initial.textContent):null;}
  if(match){section._jsidVariantLoading=false;jsidSetVariant(section,match);if(updateUrl && history.replaceState){var u=new URL(location.href);u.searchParams.set('variant',match.id);history.replaceState(history.state,'',u.toString());}return;}
  // No matching ID means NEVER submit the previously selected, potentially cheaper variant.
  section._jsidVariantLoading=false;
  jsidSetVariant(section,null);
  if(updateUrl)console.warn('JS-ID: no Shopify variant matches selected options',values);
}
function jsidInitVariants(root){
  var sections=[];
  if(root.matches&&root.matches('.jsid-product'))sections.push(root);
  root.querySelectorAll('.jsid-product').forEach(function(s){sections.push(s);});
  sections.forEach(function(section){jsidResolveVariant(section,false);});
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){jsidInitVariants(document);});
else jsidInitVariants(document);
document.addEventListener('shopify:section:load',function(e){jsidInitVariants(e.target);});
document.addEventListener('change',function(e){
  var select=e.target.closest('[data-jsid-custom-select], [data-jsid-variant-select]');
  if(!select)return;
  var section=select.closest('.jsid-product');if(!section)return;
  var variant=select.hasAttribute('data-jsid-variant-select');
  var property=section.querySelector((variant?'[data-jsid-variant-property]':'[data-jsid-custom-property]')+'[data-option-position="'+select.dataset.optionPosition+'"]');
  if(property)property.value=select.value;
  if(variant)jsidResolveVariant(section,true);
});
document.addEventListener('submit',function(e){
  var form=e.target.closest('.jsid-product-form');if(!form)return;
  var section=form.closest('.jsid-product');if(!section)return;
  // Revalidate the variant ID immediately before any native or Ajax submission.
  jsidResolveVariant(section,false);
  var v=section._jsidCurrentVariant;
  var id=form.querySelector('[data-jsid-variant-id]');
  if(!v||!v.available||!id||String(id.value)!==String(v.id)||section._jsidCartBusy){
    e.preventDefault();e.stopImmediatePropagation();
    console.error('JS-ID blocked unsafe variant submission');
  }
},true);


/* ================================
   CUSTOMER FILE UPLOAD
================================ */

document.addEventListener('change',function(e){

  var input=e.target.closest('[data-jsid-upload-input]');

  if(!input)return;

  var panel=input.closest('.jsid-upload-panel');

  if(!panel)return;

  var status=panel.querySelector('[data-jsid-upload-status]');

  if(!status)return;

  if(input.files && input.files.length){

    status.textContent='✓ ' + input.files[0].name + ' selected';

    status.classList.add('has-file');

  }else{

    status.textContent='No file selected';

    status.classList.remove('has-file');

  }

});



/* ================================
   HYBRID PERSONALISATION VALIDATION
================================ */

document.addEventListener('submit',function(e){

  var form=e.target.closest('.jsid-product-form');

  if(!form)return;

  var requiredMarker=form.querySelector('[data-jsid-require-image-or-text]');

  if(!requiredMarker)return;

  var textInput=form.querySelector('input[name="properties[Custom Text]"]');

  var uploadInput=form.querySelector('[data-jsid-upload-input]');

  var errorBox=form.querySelector('[data-jsid-personalisation-error]');

  var hasText=
    textInput &&
    textInput.value &&
    textInput.value.trim().length>0;

  var hasFile=
    uploadInput &&
    uploadInput.files &&
    uploadInput.files.length>0;

  if(!hasText && !hasFile){

    e.preventDefault();

    if(errorBox){
      errorBox.hidden=false;
      errorBox.scrollIntoView({
        behavior:'smooth',
        block:'center'
      });
    }

    if(textInput){
      try{
        textInput.focus({preventScroll:true});
      }catch(err){
        textInput.focus();
      }
    }

    return;
  }

  if(errorBox){
    errorBox.hidden=true;
  }

});


document.addEventListener('input',function(e){

  var field=e.target.closest(
    'input[name="properties[Custom Text]"]'
  );

  if(!field)return;

  var form=field.closest('.jsid-product-form');

  if(!form)return;

  var errorBox=form.querySelector('[data-jsid-personalisation-error]');

  if(errorBox && field.value.trim().length>0){
    errorBox.hidden=true;
  }

});


document.addEventListener('change',function(e){

  var upload=e.target.closest('[data-jsid-upload-input]');

  if(!upload)return;

  var form=upload.closest('.jsid-product-form');

  if(!form)return;

  var errorBox=form.querySelector('[data-jsid-personalisation-error]');

  if(
    errorBox &&
    upload.files &&
    upload.files.length>0
  ){
    errorBox.hidden=true;
  }

});

/* ================================
   HAPPY JESSI — ADD TO CART SUCCESS
================================ */

(function(){

  var successTimer = null;

  function showJSIDCartSuccess(section){
    var toast = section.querySelector('[data-jsid-cart-success]');
    if(!toast) return;

    toast.classList.add('is-visible');
    toast.setAttribute('aria-hidden','false');

    clearTimeout(successTimer);

    successTimer = setTimeout(function(){
      toast.classList.remove('is-visible');
      toast.setAttribute('aria-hidden','true');
    },3200);
  }

  document.addEventListener('submit',function(e){

    var form = e.target.closest('.jsid-product-form');
    if(!form || e.defaultPrevented) return;

    var section = form.closest('.jsid-product');
    if(!section) return;

    /*
      Keep Shopify's normal form submission for products with an actual
      customer file selected. This avoids interfering with file-upload
      line item properties.
    */
    var upload = form.querySelector('[data-jsid-upload-input]');
    if(upload && upload.files && upload.files.length){
      return;
    }

    e.preventDefault();

    var button = form.querySelector('[data-jsid-add-button]');
    if(button && button.disabled) return;

    var originalText = button ? button.textContent : '';
    section._jsidCartBusy=true;

    if(button){
      button.disabled = true;
      button.textContent = 'ADDING…';
    }

    var root =
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';

    fetch(root + 'cart/add.js',{
      method:'POST',
      headers:{
        'Accept':'application/json'
      },
      body:new FormData(form)
    })
    .then(function(response){
      if(!response.ok){
        return response.json().then(function(err){
          throw err;
        });
      }
      return response.json();
    })
    .then(function(){

      showJSIDCartSuccess(section);

      document.dispatchEvent(
        new CustomEvent('jsid:cart:refresh')
      );

      setTimeout(function(){
        document.dispatchEvent(
          new CustomEvent('jsid:cart:open')
        );
      },450);

    })
    .catch(function(error){

      console.error('JS-ID add to cart error',error);

      if(button){
        button.textContent='TRY AGAIN';
      }

    })
    .finally(function(){

      setTimeout(function(){
        section._jsidCartBusy=false;
        jsidVariantButton(section);
      },700);

    });

  });

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jsid-shop-categories"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initBHPHunt(){
    document.querySelectorAll('[data-jsid-bhp-hunt]').forEach(function(section){
      if(section.dataset.bhpReady === 'true') return;
      section.dataset.bhpReady = 'true';

      var bhp = section.querySelector('[data-jsid-bhp]');
      var modal = section.querySelector('[data-jsid-bhp-modal]');
      var closeButtons = section.querySelectorAll('[data-jsid-bhp-close]');
      var copyButton = section.querySelector('[data-jsid-bhp-copy]');

      if(!bhp || !modal) return;

      function openModal(){
        bhp.classList.add('is-found');
        window.setTimeout(function(){
          modal.classList.add('is-open');
          modal.setAttribute('aria-hidden','false');
        },260);
      }

      function closeModal(){
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden','true');
      }

      bhp.addEventListener('click',openModal);
      closeButtons.forEach(function(button){ button.addEventListener('click',closeModal); });
      document.addEventListener('keydown',function(event){ if(event.key === 'Escape') closeModal(); });

      if(copyButton){
        copyButton.addEventListener('click',function(){
          var code = copyButton.getAttribute('data-code');
          if(!code) return;

          navigator.clipboard.writeText(code).then(function(){
            copyButton.textContent='CODE COPIED ✓';
            window.setTimeout(function(){ copyButton.textContent='COPY MY CODE →'; },1800);
          });
        });
      }
    });
  }

  document.addEventListener('DOMContentLoaded',initBHPHunt);
  document.addEventListener('shopify:section:load',initBHPHunt);
  initBHPHunt();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
